export default __webpack_public_path__ + "static/media/charge_pump_negative_2_diodes.700f1934.svg";